import vehicleRntrc from './vehicle-rntrc.vue'
import VehicleService from '../../../services/vehicles'
import Auth from '../../../services/auth'

export default {
  data(){
    return {
      loading: undefined,
      vehicles: undefined,
      vehicleStatic: undefined,
      length: undefined,
      rntrc: '0000',
      editRntrc: false,
      newRntrc: undefined,
    }
  },
  computed:{
    user(){
      return Auth.currentUser;
    },
    name(){
      if(this.user.company)
        return this.user.company.companyName
      else
        return this.user.person.name + " " + this.user.person.lastName
    }
  },
  mounted(){
    $('[data-toggle="tooltip"]').tooltip();

    this.loading = VehicleService.getVehiclesToVinculateRNTRC().then((responseVehicles) => {
      this.vehicles = responseVehicles;
      this.vehicleStatic = this.vehicles;
      this.length = this.vehicles.length;
    }).catch(error => {

      if (error.data && error.data.status && error.data.status.code==9990)
        return;

      return MessageDialog.show({
        headerClass: 'modal-info',
        title: 'Erro',
        message: 'Ocorreu um erro desconhecido.',
        type: 'OK'
      });

    });

  },
  methods:{
    startEditRntrc(){
      this.editRntrc = true;
      $('[data-toggle="tooltip"]').tooltip('hide');
    },
    cancelEditRntrc(){
      this.editRntrc = false;
      this.newRntrc = undefined;
      $('[data-toggle="tooltip"]').tooltip('hide');
    },
    confirmEditRntrc(){
      this.editRntrc = false;
      this.rntrc = this.newRntrc;
      this.newRntrc = undefined;
      $('[data-toggle="tooltip"]').tooltip('hide');
    }

  },
  components:{
    vehicleRntrc
  },
}



// WEBPACK FOOTER //
// ./src/pages/account/rntrc/rntrc-vinculation.js